import { render } from "./SupportList.vue?vue&type=template&id=64803272&scoped=true"
import script from "./SupportList.vue?vue&type=script&lang=js"
export * from "./SupportList.vue?vue&type=script&lang=js"

import "./SupportList.vue?vue&type=style&index=0&id=64803272&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64803272"]])

export default __exports__